// Brouillon d'un signalement en cours de rédaction (SignalerProbleme, Task
// B2) : persisté à chaque frappe dans sessionStorage pour survivre à une
// fermeture accidentelle du <dialog>, jamais essentiel — lire/écrire/effacer
// ne jettent JAMAIS, même storage absent ou JSON corrompu (mode privé,
// contenu d'une version antérieure incompatible…).

import { GRAVITES, type Gravite } from "./schema";

export const BROUILLON_KEY = "ecoute.signalement.brouillon";

export interface Brouillon {
  description: string;
  gravite: Gravite | null;
}

type BrouillonStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

function estBrouillon(value: unknown): value is Brouillon {
  if (!value || typeof value !== "object") return false;
  const v = value as Record<string, unknown>;
  const graviteValide = v.gravite === null || GRAVITES.includes(v.gravite as Gravite);
  return typeof v.description === "string" && graviteValide;
}

export interface CreateBrouillonResult {
  lire(): Brouillon | null;
  ecrire(b: Brouillon): void;
  effacer(): void;
}

export function createBrouillon(storage: BrouillonStorage | null): CreateBrouillonResult {
  return {
    lire() {
      if (!storage) return null;
      try {
        const raw = storage.getItem(BROUILLON_KEY);
        if (!raw) return null;
        const parsed: unknown = JSON.parse(raw);
        return estBrouillon(parsed) ? parsed : null;
      } catch {
        return null;
      }
    },
    ecrire(b) {
      if (!storage) return;
      try {
        storage.setItem(BROUILLON_KEY, JSON.stringify(b));
      } catch {
        // repli silencieux : le brouillon n'est qu'un confort, pas une garantie
      }
    },
    effacer() {
      if (!storage) return;
      try {
        storage.removeItem(BROUILLON_KEY);
      } catch {
        // idem
      }
    },
  };
}
